import styled from "styled-components";

export const StyledHeader = styled.div`
	display: grid;
	width: 100%;
	transition: top 0.1s ease 0s;
	transition: height 0.1s ease 0s;
`;
